import React, { useEffect, useRef } from 'react';
import style from './index.module.scss';

function ConceptGptView() {
  const aRef = useRef();

  useEffect(() => {
    setTimeout(() => {
      if (aRef) aRef.current.click();
    }, 100);
  }, []);

  return (
    <div>
      <a
        ref={aRef}
        href="https://designnode-azure.sba.cpp.unileversolutions.com/public-webapps/conceptgpt_nutrition/"
      >
        <h1 className={style.title}>Loading....</h1>
      </a>
    </div>
  );
}

export default ConceptGptView;
